import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHint from 'react-hint';
import ControlledSelect from 'components/lib/formElements/ControlledSelect';
import SeriesTitleContainer from 'components/lib/containers/SeriesTitleContainer';
import { FeedbackBtn, PrintBtn, Toggle } from 'components/lib/buttons/IconButtons';
import Constants from 'utils/Constants';
import styles from 'styles/components/headers/menubar.css';
// import ot_printIcon from 'images/icons/ot_printIcon.png';
// import ot_commentIcon from 'images/icons/ot_commentIcon.png';

class MenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      toggleFees: false
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
    this.toggleFees = this.toggleFees.bind(this);
  }

  componentDidMount() {
    let elem = document.getElementById('printButton');
    let event;
    if(typeof(Event) === 'function') {
      event = new Event('closeEdit');
    }else{
      event = document.createEvent('Event');
      event.initEvent('closeEdit', true, true);
    }
    // let event = new Event('closeEdit');
    if (elem) {
      elem.addEventListener("mouseover", () => {
        if (this.props.selectedView === Constants.view.table) {
          window.dispatchEvent(event);
        }
      })
    }
  }

  componentWillUnmount() {
    let elem = document.getElementById('printButton');
    let event;
    if(typeof(Event) === 'function') {
      event = new Event('closeEdit');
    }else{
      event = document.createEvent('Event');
      event.initEvent('closeEdit', true, true);
    }
    // let event = new Event('closeEdit');
    if (elem) {
      elem.addEventListener("mouseover", () => {
        if (this.props.selectedView === Constants.view.table) {
          window.dispatchEvent(event);
        }
      })
    }
  }

  handlePrint() {
    window.print();
  }

  toggleFees() {
    this.setState({ toggleFees: !this.state.toggleFees});
    this.props.toggleFees();
  }

  // handlePrintElement = (id) => {
  //   // let content = document.getElementById(id).innerHTML;
  //   let headstr = "<html><head><title></title></head><body>";
  //   let footstr = "</body>";
  //   let newstr = document.all.item(id).innerHTML;
  //   let oldstr = document.body.innerHTML;
  //   document.body.innerHTML = headstr+newstr+footstr;
  //     alert(document.body.innerHTML);
  //   window.print();
  //   document.body.innerHTML = oldstr;
  //   return false;
  // }

  toggleMenu() {
    this.refs.controlledSelect.toggleMenu(!this.state.openMenu);
  }

  render() {
    let { error, label } = this.props.labels;
    let { isTouchDevice } = this.context.media;

    return (
      <section id="menubar" className={styles.menubar}>
        <div className={styles.wrapper}>
          <SeriesTitleContainer
            label={label}
            handleClick={this.toggleMenu}
            openMenu={this.state.openMenu} />
          <ControlledSelect
            ref="controlledSelect"
            clientId={this.props.clientId}
            error={error}
            items={this.props.productions}
            handleMenu={(v) => { this.setState({openMenu: v});}}
            isDialog={false}
            label={label}
            onChange={this.props.onChange}
            openMenu={this.state.openMenu}
            selectedItemName={this.props.productionName} />
          <nav className={styles.nav}>
            <ul className={styles.list}>
              <li data-rh="This includes convenience & facility fees"
                  data-rh-cls="tooltip--ot"
                  data-rh-at="bottom"
                  onTouchStart={(e) => { this.props.handleTooltip(e) }}>
                <Toggle onClick={ this.toggleFees }
                        onTouch={this.toggleFees}
                        label="Show Fees"
                        isToggle={this.state.toggleFees} />
              </li>
              { !(isTouchDevice) &&
                <li>
                  <PrintBtn id="printButton" onClick={this.handlePrint} />
                </li>
              }
              <li>
                <FeedbackBtn href="http://bit.ly/2u3odda" />
              </li>
            </ul>
          </nav>
        </div>

      </section>
    );
  }
}


MenuBar.propTypes = {
  clientId: PropTypes.number,
  selectError: PropTypes.string,
  productions: PropTypes.array,
  selectLabel: PropTypes.string,
  onChange: PropTypes.func
};
MenuBar.contextTypes = {
  media: PropTypes.object
};
export default MenuBar;



// WEBPACK FOOTER //
// ./src/scripts/components/headers/MenuBar.js